import { render, staticRenderFns } from "./OrderLineItems.vue?vue&type=template&id=672d0a8c&"
import script from "./OrderLineItems.ts?vue&type=script&lang=js&"
export * from "./OrderLineItems.ts?vue&type=script&lang=js&"
import style0 from "./OrderLineItems.vue?vue&type=style&index=0&id=672d0a8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports